var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from "react";
import { useHistory } from "react-router-dom";
import { Pane, Row, Col, PaneFooter, ErrorModal, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useForm, Controller } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import * as z from "zod";
import { RecekTextArea } from "../../components/inputs";
import { navigation } from "../../components/navigation";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { useModal } from "../../utils/useModal";
import { FormFooterStart } from "../../components/FormFooterStart";
import { FormFooterEnd } from "../../components/FormFooterEnd";
var createReportChangeSchema = function (formatMessage) {
    return z.object({
        changeDescription: z
            .string()
            .min(1, formatMessage({ id: "ui-br-agency.validation.required" })),
    });
};
export var LegalPersonReportChangeForm = function (_a) {
    var legalPerson = _a.legalPerson, onSubmit = _a.onSubmit, title = _a.title;
    var formatMessage = useIntl().formatMessage;
    var history = useHistory();
    var _b = useModal(), isOpen = _b.isOpen, message = _b.message, openModal = _b.openModal, closeModal = _b.closeModal;
    var _c = useForm({
        resolver: zodResolver(createReportChangeSchema(formatMessage)),
        defaultValues: { changeDescription: "" },
        mode: "onBlur",
    }), handleSubmit = _c.handleSubmit, control = _c.control;
    var handleFormSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, onSubmit(data)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    openModal(formatMessage({ id: "ui-br-agency.legal-person.error.reportChange" }));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getDisplayName = function () {
        if (legalPerson.name) {
            return legalPerson.name;
        }
        return legalPerson.sourceId || legalPerson.id;
    };
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { defaultWidth: "fill", paneTitle: title, footer: React.createElement(PaneFooter, { renderStart: React.createElement(FormFooterStart, { handleSubmit: handleSubmit, onSubmit: handleFormSubmit, buttonMessageId: "ui-br-agency.button.submit" }), renderEnd: React.createElement(FormFooterEnd, { onCancel: function () {
                        return navigation.legalPersons &&
                            history.push(navigation.legalPersons.path);
                    }, buttonMessageId: "ui-br-agency.button.cancel" }) }) },
            React.createElement(ErrorModal, { open: isOpen, label: formatMessage({ id: "ui-br-agency.modal.label.error" }), content: message, onClose: closeModal }),
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12 },
                    React.createElement("h3", null,
                        React.createElement(FormattedMessage, { id: "ui-br-agency.legal-person.reportChange.personInfo", values: { name: getDisplayName() } })))),
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12 },
                    React.createElement("p", null,
                        React.createElement("strong", null,
                            React.createElement(FormattedMessage, { id: "ui-br-agency.legal-person.sourceId.field.label" }),
                            ":"),
                        " ",
                        legalPerson.sourceId))),
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12 },
                    React.createElement("p", null,
                        React.createElement("strong", null,
                            React.createElement(FormattedMessage, { id: "ui-br-agency.legal-person.name.field.label" }),
                            ":"),
                        " ",
                        legalPerson.name))),
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12 },
                    React.createElement("p", null,
                        React.createElement("strong", null,
                            React.createElement(FormattedMessage, { id: "ui-br-agency.legal-person.residence.field.label" }),
                            ":"),
                        " ",
                        legalPerson.residence))),
            React.createElement("form", { noValidate: true, onSubmit: handleSubmit(handleFormSubmit) },
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(Controller, { control: control, name: "changeDescription", render: function (_a) {
                                var _b;
                                var field = _a.field, fieldState = _a.fieldState;
                                return (React.createElement(RecekTextArea, __assign({}, field, { labelId: "ui-br-agency.legal-person.changeDescription.field.label", placeholder: formatMessage({
                                        id: "ui-br-agency.legal-person.changeDescription.placeholder",
                                    }), required: true, error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message, fullWidth: true })));
                            } })))))));
};
